import './sentry'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import '@rainbow-me/rainbowkit/styles.css'
import './styles/global.css'
import { wagmiConfig } from './wagmi.ts'
import { purpleTheme } from './rainbowKitTheme.ts'
import App from './App.tsx'
import { SolanaWalletProvider } from './solana.tsx'
import { initAnalytics } from './lib/analytics.ts'

const queryClient = new QueryClient()

initAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <SolanaWalletProvider>
            <RainbowKitProvider theme={purpleTheme} modalSize="compact">
              <App />
            </RainbowKitProvider>
          </SolanaWalletProvider>
        </QueryClientProvider>
      </WagmiProvider>
  </StrictMode>,
)
